import office from 'src/services/office';

export async function openPopupWindow(url, params = {}) {
  const isExcelOnline = (office.platformType === Office.PlatformType.OfficeOnline);

  const { width = 450, height = 575, useBrowser, } = params;

  if (useBrowser && !isExcelOnline) {
    Office.context.ui.openBrowserWindow(url);
    return;
  }

  const [top, left] = [screen.height / 2 - height / 2, screen.width / 2 - width / 2];
  const features = `directories=no,menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=${width},height=${height},top=${top},left=${left}`;

  const popup = isExcelOnline && window.open('', 'authorization', features);
  if (!popup) {
    window.open(url, 'authorization', features);
  }
  else {
    popup.location = url;
  }
}
